import Vue from 'vue'
import App from './App.vue'
import { Button, message, Layout, Menu, Icon, Row, Col, Form, FormModel, Radio, Input, Card, Checkbox, Table, PageHeader, Result, Modal, Select, Divider, InputNumber, Switch, Avatar, DatePicker, Tooltip, Transfer, Upload, Badge, Dropdown } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Table)
Vue.use(PageHeader)
Vue.use(Result)
Vue.use(Modal)
Vue.use(Select)
Vue.use(Divider)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Avatar)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Transfer)
Vue.use(Upload)
Vue.use(Badge)
Vue.use(Dropdown)

Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$error = Modal.error;
Vue.prototype.$success = Modal.success;

Vue.prototype.$message = message;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
